import React, { useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { useClickOutside } from '../../hooks/useClickOutside.tsx'

export interface MenuItem {
  icon?: React.ReactNode
  key: string
  action: (e: React.MouseEvent<HTMLButtonElement>) => void
}

export interface ContextMenuState {
  isOpen: boolean
  position: {
    left?: number
    top: number
    right?: number
  }
}

interface ContextMenuProps extends ContextMenuState {
  viewModel: MenuItem[]
  triggerRef?: React.RefObject<HTMLElement>
  setIsOpen: (isOpen: boolean) => void
}

const ContextMenu: React.FC<ContextMenuProps> = ({
  viewModel,
  isOpen,
  triggerRef,
  setIsOpen,
  position,
}) => {
  const { t } = useTranslation()
  const menuRef = useRef<HTMLDivElement>(null)

  useClickOutside({
    itemRef: menuRef,
    triggerRef: triggerRef ?? menuRef,
    isOpen,
    setIsOpen,
  })

  return (
    <div
      ref={menuRef}
      style={{
        left: position?.left,
        top: position?.top,
        right: position?.right,
      }}
      className={`absolute z-50 h-auto w-[188px] transform overflow-hidden rounded-md bg-zinc-900 shadow-lg ring-1 ring-black/5 transition-transform ${
        isOpen
          ? 'scale-100 opacity-100'
          : 'pointer-events-none scale-95 opacity-0'
      }`}
    >
      <ul>
        {viewModel.map((item) => (
          <li key={item.key}>
            <button
              onClick={(e) => {
                setIsOpen(false)
                item.action(e)
              }}
              className="flex h-10 w-full items-center gap-2 px-4 py-2 text-white hover:bg-zinc-700 focus:outline-none"
            >
              {item.icon && <span>{item.icon}</span>}
              <span className="text-sm font-medium leading-5 text-white">
                {t(item.key)}
              </span>
            </button>
          </li>
        ))}
      </ul>
    </div>
  )
}

export default ContextMenu
